import {Directive, Output, Input, EventEmitter, HostBinding, HostListener, ElementRef} from '@angular/core';

@Directive({
    selector: '[appDragDrop]'
})
export class DragDropDirective {
    element: HTMLElement;
    @Output() onFileDropped = new EventEmitter<any>();

    @HostBinding('style.background-color') private background = 'transparent'
    @HostBinding('style.opacity') private opacity = '1'
    @HostBinding('class.ondrop') private on_drop = false

    constructor(el: ElementRef) {
      this.element = el.nativeElement;
    }
    //Dragover listener
    @HostListener('dragover', ['$event']) onDragOver(evt) {
        evt.preventDefault();
        evt.stopPropagation();
       /* this.background = '#9ecbec';
        this.opacity = '0.8'*/
        this.on_drop = true;
    }

    //Dragleave listener
    @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        //this.background = '#f5fcff'
        this.opacity = '1'
        if(!this.isDescendant(this.element, evt.target)) this.on_drop = false;
    }

    //Drop listener
    @HostListener('drop', ['$event']) public ondrop(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        //this.background = '#f5fcff'
        this.opacity = '1'
        let files = evt.dataTransfer.files;
        if (files.length > 0) {
            this.onFileDropped.emit(files)
        }
        this.on_drop = false;
    }


  isDescendant(parent: HTMLElement, child: HTMLElement) {
    var node = child.parentNode;
    while (node != null) {
      if (node == parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/injection/drag-drop.directive.ts